import { CalendarCheck2, Flame, TrendingUp } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { PageTitle, useApi, Skeleton, Stagger, Item } from "@/components/portal/ui";
import AttendanceLeaderboard from "@/pages/portal/AttendanceLeaderboard";

export default function Kehadiran() {
  const { data } = useApi("/portal/attendance");
  const stats = data ? [["Total Hadir", data.total, CalendarCheck2], ["Bulan Ini", data.this_month, TrendingUp], ["Minggu Beruntun", data.weeks_streak, Flame]] : [];
  const max = data ? Math.max(1, ...Object.values(data.by_schedule)) : 1;
  return (
    <div data-testid="portal-kehadiran">
      <PageTitle eyebrow="Kesetiaan" title="Riwayat Kehadiran" />
      <div className="px-5 mt-4 space-y-5">
        {!data ? <Skeleton className="h-64" /> : (
          <Stagger className="space-y-5">
            <Item className="grid grid-cols-3 gap-3">
              {stats.map(([l, v, Icon], i) => (
                <div key={l} className={`rounded-3xl p-4 border border-slate-100 shadow-sm ${i === 0 ? "bg-blue-600 text-white" : "bg-white"}`} data-testid={`attendance-stat-${i}`}>
                  <Icon className="w-4 h-4 opacity-80" /><p className="mt-3 text-2xl font-black tabular-nums">{v}</p><p className="text-[11px] opacity-70">{l}</p>
                </div>
              ))}
            </Item>
            {Object.keys(data.by_schedule).length > 0 && (
              <Item className="bg-white rounded-3xl p-5 border border-slate-100 shadow-sm space-y-3">
                <p className="text-sm font-bold text-slate-900">Per Ibadah</p>
                {Object.entries(data.by_schedule).map(([t, c]) => (
                  <div key={t}><div className="flex justify-between text-xs"><span className="font-semibold text-slate-700">{t}</span><span className="text-slate-500">{c}x</span></div>
                    <div className="mt-1.5 h-2 rounded-full bg-slate-100 overflow-hidden"><div className="h-full rounded-full bg-blue-600" style={{ width: `${(c / max) * 100}%` }} /></div></div>
                ))}
              </Item>
            )}
            <Item className="space-y-3">
              <AttendanceLeaderboard />
            </Item>
            <Item className="space-y-3">
              <p className="px-1 text-sm font-bold text-slate-900">Riwayat</p>
              {data.items.length === 0 && <p className="text-sm text-slate-500 px-1" data-testid="attendance-empty">Belum ada kehadiran. Tunjukkan QR Digital Card saat ibadah.</p>}
              {data.items.map((c) => (
                <div key={c.id} className="bg-white rounded-2xl p-4 border border-slate-100 shadow-sm flex items-center gap-4" data-testid={`attendance-${c.id}`}>
                  <span className="w-11 h-11 rounded-xl bg-emerald-500 text-white grid place-items-center font-black text-sm">{fmtDate(c.date, { day: "2-digit" })}</span>
                  <div className="flex-1"><p className="font-bold text-slate-900 text-sm">{c.schedule_title}</p><p className="text-xs text-slate-500">{fmtDate(c.date, { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</p></div>
                  <span className="text-xs font-semibold text-slate-500 tabular-nums">{new Date(c.created_at).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })}</span>
                </div>
              ))}
            </Item>
          </Stagger>
        )}
      </div>
    </div>
  );
}
